module.exports = __webpack_public_path__ + "static/media/loading-pulse.3b20f6ee.svg";